<template>
<b-container>


  <b-card no-body class="overflow-hidden">
    <b-form v-on:submit.prevent id="profile-form">
    <b-row no-gutters>

      <b-col md="4">
        <br>
      <b-nav-dropdown id="profddown" class="no-bullets" right v-if="!uploading">
             <template slot="button-content"><b-avatar style="border: none" :src="form.image" variant="light" size="10rem"></b-avatar></template>
      <b-dropdown-form>
        <b-form-group label="Profile Image" label-for="profile-image" @submit.stop.prevent>
          <b-form-file accept=".jpg, .png" id="profile-image" placeholder="Upload jpg / png" v-model="file" size="sm"></b-form-file>
        </b-form-group>
      </b-dropdown-form>
      </b-nav-dropdown>
        <b-spinner v-if="uploading" style="width: 3rem; height: 3rem;"></b-spinner>

      </b-col>
      <b-col md="8">
        <b-card-body title="Your Profile">
          <b-card-text style="white-space: normal;">
            {{ biography }}
          </b-card-text>
           <b-form-textarea
      id="textarea"
      v-model="form.bio"
      placeholder="Enter something..."
      rows="3"
    ></b-form-textarea>

        </b-card-body>
      </b-col>
    </b-row>
      <b-tabs content-class="mt-3">
        <b-tab title="Details" active>
      <b-card-body>
        <b-row>

    <b-col md="3" offset-lg="1" offset="0" class="py-0">
      <b-form-group id="fieldset-first-name" label="First Name *" label-align="left" label-for="first-name-id" label-size="sm">
    <b-form-input id="first-name-id" size="sm" v-model="form.first_name" :required="true" type="text"></b-form-input>

    </b-form-group>
    </b-col>
      <b-col md="3" class="py-0">
      <b-form-group id="fieldset-last-name" label="Last Name *" label-align="left" label-for="last-name-id" label-size="sm">
    <b-form-input id="last-name-id" size="sm" v-model="form.last_name" :required="true" type="text"></b-form-input>
    </b-form-group>
              </b-col>

        </b-row>
                        <b-row>
    <b-col md="6" offset-lg="1" offset="0" class="py-0">
      <b-form-group id="fieldset-company" label="Company *" label-align="left" label-for="company-id" label-size="sm">

    <b-form-input id="company-id" size="sm" v-model="form.company" :required="true" type="text"></b-form-input>
    </b-form-group>
    </b-col>
        </b-row>
            <b-row>
    <b-col md="3" offset-lg="1" offset="0" class="py-0">
      <b-form-group id="fieldset-title" label="Job Title *" label-align="left" label-for="title-id" label-size="sm">

    <b-form-input id="title-id" size="sm" v-model="form.jobtitle" :required="true" type="text"></b-form-input>
    </b-form-group>
    </b-col>
            <b-col md="3" class="py-0">
      <b-form-group id="fieldset-jobfunction" :label="$store.state.globalTheme.JOB_FUNCTION_ALIAS" label-align="left" label-for="job-function-id" label-size="sm">
        <b-form-select v-model="form.jobfunction" :options="jobfunction" size="sm" text-field="name" value-field="id" id="job-function-id"></b-form-select>
      </b-form-group>
        </b-col>
        </b-row>
    <b-row>
    <b-col md="6" offset-lg="1" offset="0" class="py-0">
      <b-form-group id="fieldset-phone" label="Contact Number" label-align="left" label-for="phone-id" label-size="sm">

    <b-form-input v-model="form.phone" id="phone-id" size="sm" type="text"></b-form-input>
    </b-form-group>
    </b-col>
        </b-row>

    <b-row>
    <b-col md="6" offset-lg="1" offset="0" class="py-0">
      <b-form-group id="fieldset-add-search" label="Enter Address" label-align="left" label-for="add-search-id" label-size="sm">

    <b-form-input placeholder="Search Postal Address" v-model="searchedAddress" class="search-location" id="add-search-id" size="sm" type="text"></b-form-input>
    </b-form-group>
    </b-col>
        </b-row>

    <b-row v-if="hasAddress">
    <b-col md="3" offset-lg="1" offset="0" class="py-0">
      <b-form-group id="fieldset-add1" label="Address 1" label-align="left" label-for="add1-id" label-size="sm">

    <b-form-input id="add1-id" size="sm" v-model="form.add1" type="text"></b-form-input>
    </b-form-group>
    </b-col>
      <b-col md="3" class="py-0">
      <b-form-group id="fieldset-add2" label="Address 2" label-align="left" label-for="add2-id" label-size="sm">
    <b-form-input id="add2-id" size="sm" v-model="form.add2" type="text"></b-form-input>
    </b-form-group>
              </b-col>
        </b-row>

    <b-row v-if="hasAddress">
    <b-col md="6" offset-lg="1" offset="0" class="py-0">
      <b-form-group id="fieldset-city" label="City" label-align="left" label-for="city-id" label-size="sm">

    <b-form-input id="city-id" size="sm" v-model="form.city" type="text"></b-form-input>
    </b-form-group>
    </b-col>
        </b-row>

    <b-row v-if="hasAddress">
    <b-col md="6" offset-lg="1" offset="0" class="py-0">
      <b-form-group id="fieldset-county" label="County" label-align="left" label-for="county-id" label-size="sm">

    <b-form-input id="county-id" size="sm" v-model="form.county" type="text"></b-form-input>
    </b-form-group>
    </b-col>

    </b-row>

    <b-row v-if="hasAddress">

    <b-col md="3" offset-lg="1" offset="0" class="py-0">
      <b-form-group id="fieldset-postcode" label="Postcode" label-align="left" label-for="postcode-id" label-size="sm">

    <b-form-input id="postcode-id" size="sm" v-model="form.postcode" type="text"></b-form-input>
    </b-form-group>
    </b-col>
      <b-col md="3" class="py-0">
      <b-form-group id="fieldset-country" label="Country" label-align="left" label-for="country-id" label-size="sm">
    <b-form-input id="country-id" size="sm" v-model="form.country" type="text"></b-form-input>
    </b-form-group>
              </b-col>
        </b-row>

      <b-row>
        <b-col md="6" offset-lg="1" offset="0" class="py-0">
      <b-form-group id="fieldset-industry" :label="$store.state.globalTheme.INDUSTRY_ALIAS" label-align="left" label-for="industry-id" label-size="sm">
        <b-form-select v-model="form.industry" :options="industry" size="sm" text-field="name" value-field="id" id="industry-id"></b-form-select>
      </b-form-group>
        </b-col>
      </b-row>
          <b-row>
        <b-col md="6" offset-lg="1" offset="0" class="py-0">
      <b-form-group id="fieldset-department" :label="$store.state.globalTheme.DEPARTMENT_ALIAS" label-align="left" label-for="department-id" label-size="sm">
        <b-form-select v-model="form.department" :options="department" size="sm" text-field="name" value-field="id" id="department-id"></b-form-select>
      </b-form-group>
        </b-col>
      </b-row>
        <b-row>
          <b-col md="6" offset-lg="1" offset="0" class="py-0">
          <b-button type="submit" @click="onSubmit" block variant="primary">Update</b-button>
          </b-col>
        </b-row>
    </b-card-body>
        </b-tab>

      <b-tab title="Subscriptions">
        <b-card-body>
        <b-row>
            <b-col md="6" lg="4" offset="4">
            <b-card title="Active Subscriptions">
              <p v-if="form.subscriptions.length == 0">No Subscriptions</p>
              <ul>
              <li v-for="s in form.subscriptions">
                <p style="text-align: left" v-if="s.expiry"><b>{{ s.group_name }}</b> - Expires {{ s.expiry }}</p>
                <p style="text-align: left" v-else ><b>{{ s.group_name }}</b> - Never Expires<p/>
              </li>
              </ul>
            </b-card>
          </b-col>
      </b-row>
      </b-card-body>
      </b-tab>


      </b-tabs>
      </b-form>
  </b-card>
</b-container>

</div>

</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
  import { getAPI } from '../store/axios-base'
  import Multiselect from 'vue-multiselect'

    export default {
        name: "profile.vue",
        data:()=>{
            return {
                form: {
                first_name:'',
                last_name:'',
                company:'',
                jobtitle:'',
                image:'',
                bio:'',
                add1:'',
                add2:'',
                city:'',
                county:'',
                postcode:'',
                country:'',
                voucher:'',
                phone:'',
                subscriptions:[],
                industry:[],
                department:[],
                jobfunction:[]
                },
                file:null,
                industry:[],
                department:[],
                jobfunction:[],
                uploading: false,
                searchedAddress: '',

            }

    },

    computed: {

        biography: function () {
            if(this.form.bio){
                return this.form.bio
            } else {
                return 'Nothing here yet, tell us about yourself!'
            }
        },

      hasAddress:function(){
            if((this.form.add1 || this.form.add2  || this.form.city || this.form.county || this.form.country || this.form.postcode)){
                return true
            } else {
                return false
            }
        }

    },
    watch:{
      file (newvar, oldvar) {
          var file =this.file
          this.fileSubmit(file)

      }

    },

    methods:{

      validateField:function(item){
            if(Boolean(item)){
                return true
            }  else {
                return null

            }
        },


      fileSubmit:function(file){
          this.uploading = true
          let formData = new FormData();
          formData.append('file', file);
          var headers = { Authorization: `Bearer ${this.$store.state.accessToken}` }

          getAPI.post('/api/account/image/',formData,{ headers: headers }).then(response=>{
              this.form.image = response.data.profile_image
              this.$parent.profile_image = response.data.profile_image
              this.$parent.showAlert('imageupdated')
              this.uploading = false
          })

      },

      onSubmit:function(){
            if(this.$store.getters.loggedIn && this.form.first_name && this.form.last_name && this.form.company && this.form.jobtitle) {
                var headers = { Authorization: `Bearer ${this.$store.state.accessToken}` }


            getAPI.post("/api/account/profile/",this.form,{ headers: headers }).then(response => {
                this.$parent.showAlert('updated')
                window.scrollTo(0,0);

          })
            }},

      FetcProfile:function(){
            if(this.$store.getters.loggedIn) {
                var headers = { Authorization: `Bearer ${this.$store.state.accessToken}` }

            getAPI.get("/api/account/profile/",{ headers: headers }).then(response => {
                this.form = response.data

                if(response.data.image == '' || response.data.image === null){
                    this.form.image = ''
                    }
                  })
            }},

      FetchSelectOptions:function(){

          getAPI.get("/api/account/industries/").then(response => {
              this.industry = response.data
          })
          getAPI.get("/api/account/departments/").then(response => {
              this.department = response.data
          })

          getAPI.get("/api/account/jobfunctions/").then(response => {
              this.jobfunction = response.data
          })

      },

      startAutocomplete:function () {

            this.autocomplete = new google.maps.places.Autocomplete(
            document.getElementById('add-search-id'),
            {types: ['geocode']}
            );

            this.autocomplete.addListener('place_changed', () => {

            let place = this.autocomplete.getPlace();
            let address = place.address_components

            this.searchedAddress = place.formatted_address

            var ad = {};
            var i;

            for (i = 0; i < address.length; i++) {
                ad[address[i].types[0]] = address[i].long_name
            }

            var street = ((ad['street_number'] || '') + ' ' + (ad['route'] || '')).trim()
            if(ad.premise){
                this.form.add1 = ad.premise
                this.form.add2 = street
            } else {
                this.form.add1 = street
                this.form.add2 = ''
            }

            this.form.city = ad.postal_town || ad.locality || ad.sublocality || ad.sublocality_level_1 || ''
            this.form.county = ad.administrative_area_level_2 || ad.administrative_area_level_1 || ''
            this.form.country = ad.country || ''
            this.form.postcode = ad.postal_code || ad.postal_code_prefix || ''
              });
          }},
        mounted() {
            this.FetcProfile()
            this.FetchSelectOptions()
            if(this.$route.query.a){
              this.$parent.showAlert(this.$route.query.a)
              }
              this.startAutocomplete()
      },
      components:{
            Multiselect
      }
}

</script>

<style>
      .multiselect__tag {
  background: var(--main-color)
  }
  .multiselect__option--highlight {
    background: var(--main-color)
  }

</style>

<style scoped>
.no-bullets {
    list-style-type: none;
}
</style>



// WEBPACK FOOTER //
// src/components/profile.vue